// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getUserAdminStatus = async ({
    test,
}: {
    test: boolean,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleGetUserAdminStatus = httpsCallable<
        Record<
            string,
            boolean
        >,
        boolean
    >(
        functions,
        'getUserAdminStatus',
    );
    return handleGetUserAdminStatus({
        test,
    }).then((result) => {
        const isAdmin = result.data as boolean;
        return isAdmin;
    }).catch((err) => {
        throw err;
    });
};

export default getUserAdminStatus;
